/* ==========================================================================
   Fat Smith theme — global behaviours
   AJAX cart, cart drawer, mobile nav, quantity steppers, variant picker,
   predictive search. Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.FatSmith && window.FatSmith.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Drawer / overlay helpers ---------- */
  const overlay = () => $('#overlay');
  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    const o = overlay(); if (o) o.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeDrawers() {
    $$('.cart-drawer, .mobile-nav').forEach((d) => d.setAttribute('aria-hidden', 'true'));
    const o = overlay(); if (o) o.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-open-cart]') || e.target.closest('[data-open-cart]')) {
      // only intercept if a cart drawer exists; otherwise let the link go to /cart
      const drawer = $('#cart-drawer');
      if (drawer) { e.preventDefault(); refreshCartDrawer().then(() => openDrawer(drawer)); }
    }
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); openDrawer($('#mobile-nav')); }
    if (e.target.closest('[data-close-drawer]') || e.target.id === 'overlay') closeDrawers();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart API ---------- */
  async function getCart() {
    const r = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  async function refreshCartCount() {
    try { const c = await getCart(); updateCartCount(c.item_count); } catch (e) {}
  }

  async function addToCart(form, button) {
    const formData = new FormData(form);
    setLoading(button, true);
    try {
      const r = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await r.json();
      if (!r.ok) {
        showFormError(form, data.description || data.message || 'Could not add to bag.');
        return;
      }
      const cart = await getCart();
      updateCartCount(cart.item_count);
      const drawer = $('#cart-drawer');
      if (drawer) { await refreshCartDrawer(cart); openDrawer(drawer); }
      else window.location = `${root}cart`;
    } catch (err) {
      showFormError(form, 'Network error. Try again.');
    } finally {
      setLoading(button, false);
    }
  }

  async function changeLine(line, quantity) {
    const r = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    return r.json();
  }

  function setLoading(button, on) {
    if (!button) return;
    button.classList.toggle('loading', on);
    button.toggleAttribute('aria-busy', on);
    button.disabled = on;
  }
  function showFormError(form, msg) {
    let el = form.querySelector('[data-form-error]');
    if (!el) { el = document.createElement('div'); el.setAttribute('data-form-error', ''); el.className = 'form-status form-status--error'; form.appendChild(el); }
    el.textContent = msg;
  }

  /* product / featured-product add-to-cart forms */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const action = (form.getAttribute('action') || '').split('?')[0];
    const isCartAdd = /\/cart\/add$/.test(action);
    if (form.matches('[data-ajax-cart]') || isCartAdd) {
      e.preventDefault();
      addToCart(form, form.querySelector('[type="submit"]'));
    }
  });

  /* ---------- Cart drawer render ---------- */
  async function refreshCartDrawer(cart) {
    const body = $('#cart-drawer-body');
    const foot = $('#cart-drawer-foot');
    if (!body) return;
    cart = cart || (await getCart());
    updateCartCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn--secondary btn--sm" href="${root}collections/all" data-close-drawer style="margin-top:16px">Keep skating</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item" data-line="${i + 1}">
        <a class="cart-item__img" href="${item.url}">${item.image ? `<img src="${item.image.replace(/(\.[^.]+)(\?|$)/, '_160x160$1$2')}" alt="" loading="lazy">` : ''}</a>
        <div>
          <a class="cart-item__title" href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="quantity" style="margin-top:10px;transform:scale(.85);transform-origin:left">
            <button type="button" data-line-minus aria-label="Decrease">&minus;</button>
            <input type="number" value="${item.quantity}" min="0" data-line-qty aria-label="Quantity">
            <button type="button" data-line-plus aria-label="Increase">+</button>
          </div>
        </div>
        <div class="cart-item__right">
          <div>${money(item.final_line_price)}</div>
          <button class="cart-item__remove" type="button" data-line-remove>Remove</button>
        </div>
      </div>`).join('');
    const sub = $('#cart-drawer-subtotal'); if (sub) sub.textContent = money(cart.total_price);
  }

  /* drawer + cart page line item interactions (delegated) */
  document.addEventListener('click', async (e) => {
    const itemEl = e.target.closest('[data-line]');
    if (!itemEl) return;
    const line = parseInt(itemEl.dataset.line, 10);
    const input = itemEl.querySelector('[data-line-qty]');
    if (e.target.matches('[data-line-plus]')) updateLine(line, parseInt(input.value, 10) + 1, itemEl);
    if (e.target.matches('[data-line-minus]')) updateLine(line, parseInt(input.value, 10) - 1, itemEl);
    if (e.target.matches('[data-line-remove]')) updateLine(line, 0, itemEl);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-line-qty]')) {
      const itemEl = e.target.closest('[data-line]');
      updateLine(parseInt(itemEl.dataset.line, 10), parseInt(e.target.value, 10), itemEl);
    }
  });
  async function updateLine(line, qty, itemEl) {
    itemEl.style.opacity = '.5';
    const cart = await changeLine(line, Math.max(0, qty));
    // If on cart page, full reload reflects totals/promotions reliably.
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    await refreshCartDrawer(cart);
  }

  /* ---------- Quantity steppers (forms) ---------- */
  document.addEventListener('click', (e) => {
    const q = e.target.closest('.quantity');
    if (!q || e.target.closest('[data-line]')) return;
    const input = q.querySelector('input');
    if (!input) return;
    if (e.target.matches('[data-qty-plus]')) input.value = parseInt(input.value || 1, 10) + 1;
    if (e.target.matches('[data-qty-minus]')) input.value = Math.max(parseInt(input.min || 1, 10), parseInt(input.value || 1, 10) - 1);
  });

  /* ---------- Variant picker ---------- */
  class VariantPicker {
    constructor(el) {
      this.el = el;
      this.data = JSON.parse($('[data-variant-json]', el).textContent);
      this.form = $('[data-ajax-cart]', el) || el.closest('form');
      el.addEventListener('change', () => this.onChange());
    }
    selectedOptions() {
      return $$('[data-variant-option]', this.el).map((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) return checked.value;
        const select = group.querySelector('select');
        return select ? select.value : null;
      });
    }
    onChange() {
      const opts = this.selectedOptions();
      const match = this.data.find((v) => v.options.every((o, i) => o === opts[i]));
      const idInput = this.form && this.form.querySelector('[name="id"]');
      const priceEl = $('[data-price]', this.el.closest('[data-product-root]') || document);
      const addBtn = this.form && this.form.querySelector('[type="submit"]');
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.dataset.addText || 'Add to bag') : (addBtn.dataset.soldText || 'Sold out');
      }
      if (priceEl && match.price != null) priceEl.innerHTML = money(match.price);
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }
  $$('[data-variant-picker]').forEach((el) => new VariantPicker(el));

  /* ---------- Product media thumbs ---------- */
  $$('[data-media-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-media-thumb]');
      if (!thumb) return;
      const id = thumb.dataset.mediaThumb;
      $$('[data-media-slide]', gallery).forEach((s) => s.classList.toggle('is-active', s.dataset.mediaSlide === id));
      $$('[data-media-thumb]', gallery).forEach((t) => t.classList.toggle('is-active', t === thumb));
    });
  });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive-search]').forEach((wrap) => {
    const input = $('input[type="search"]', wrap);
    const results = $('[data-predictive-results]', wrap);
    if (!input || !results) return;
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=6&section_id=predictive-search`, { headers: { Accept: 'application/json' } });
          const data = await r.json();
          const items = (data.resources.results.products || []);
          if (!items.length) { results.innerHTML = '<div style="padding:14px;color:var(--color-text-muted)">No matches.</div>'; results.hidden = false; return; }
          results.innerHTML = items.map((p) => `
            <a class="predictive-item" href="${p.url}">
              ${p.image ? `<img src="${p.image}" alt="" width="44" height="44" loading="lazy">` : ''}
              <span>${p.title}</span>
              <span class="predictive-item__price">${p.price ? money(parseFloat(p.price.replace(/[^0-9.]/g, '')) * 100) : ''}</span>
            </a>`).join('');
          results.hidden = false;
        } catch (e) { results.hidden = true; }
      }, 220);
    });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) results.hidden = true; });
  });

  /* ---------- Newsletter / contact AJAX status is native via Shopify form ---------- */

  /* ---------- Sticky header shadow ---------- */
  const header = $('.header__sticky');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 6px 24px rgba(0,0,0,.5)' : 'none';
    }, { passive: true });
  }

  /* ---------- init ---------- */
  refreshCartCount();
  window.FatSmithCart = { refresh: refreshCartCount, drawer: refreshCartDrawer, getCart };
})();
